module.exports = "https://cdn.redage.net/src/views/player/help/images/2472.jpg";